<template>
  <span>
    <input ref="file" type="file" class="form-control" placeholder="" style="" hidden @change="selectFile"  multiple>
<!--    multiple-->
<!--    accept=".png,.jpg,.jpeg,.gif"-->



  </span>
</template>

<script>

/**
 <FileUploadAndProcess ref="fileUploadAndProcess" file-size-mega="30" v-on:uploadSuccess="uploadSuccess" />

 uploadSuccess(fileUrls){
      let loader=util.ShowLoading(this);

      apiCheckIn.api_CheckInImportExcel(fileUrls).then(()=>{
        this.loadData()
        util.HideLoading(loader);
      });
    }

**/
// import apiUBossBk from "@/pages/ubossBk/util/apiUBossBk";
// import apiUBossCommonFileSec from "@/pages/commonUBoss/apiUBossCommonFileSec";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";

export default {
  props: ["fileSizeMega"],
  data: function () {
    return {
      selectdFiles:undefined,
    };
  },
  methods: {
    popupFileUpload(){
      let fileInputElement = this.$refs.file;
      fileInputElement.click();
    },
    selectFile(event){
      this.selectdFiles=event.target.files;

      //-------------檔案大小限制--------------------------
      const file = this.selectdFiles[0];

      if (!file) {
        alert('請選擇一個檔案');
        return;
      }

      if (file.size > this.fileSizeMega*1024 * 1024) {
        alert("檔案太大 (需小於 "+this.fileSizeMega+"MB)");
        return;
      }
      //---------------------------------------

      this.uploadFiles();
      event.target.value=null;


      // doc event.target.files 的內容
      // lastModified: 1612407992013
      // lastModifiedDate: Thu Feb 04 2021 11:06:32 GMT+0800 (台北標準時間) {}
      // name: "GPKlogo2.png"
      // size: 45641
      // type: "image/png"
      // webkitRelativePath: ""
    },
    uploadFiles(){
      let uploadFiles=this.selectdFiles;

      apiAdmin.api_uploadWaitProcess(uploadFiles).then((result)=>{
        this.$emit('uploadSuccess',result.data.FileUrls)
      })


    },
    loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
  },
  mounted() {


    //this.loadData()
  },
}
</script>

<style scoped>

</style>
